import React, {useEffect, useState, useCallback} from 'react';
import {useNavigate, useLocation, useParams} from 'react-router-dom';
import {ExcelDowloader} from './excel_download';
import LocationPosterButton from './location_poster';
import { useDispatch } from 'react-redux';

const formatDisplayValue = value => {
  if (!value) return '—';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  return [value.street, value.street2, value.city, value.region, value.postal, value.country].filter(Boolean).join(', ') || '—';
};

export const Location = () => {


  const dispatch = useDispatch();
  const logoutUser = () => {
    dispatch({ type: 'LOG_OUT', payload: null });
    sessionStorage.setItem('currentUser', null);
    window.location = "/";
  };

  const [hasLocationData, setHasLocationData] = useState(false);
  const [locationPhone, setLocationPhone] = useState("");
  const [locationName, setLocationName] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [schedules, setSchedules] = useState([])
  const [formattedSchedules, setFormattedSchedules] = useState([])
  const [hasSchedules, setHasSchedules] = useState(false);
  const [districtName, setDistrictName] = useState("");
  const [locationNumber, setLocationNumber] = useState("");
  const locationRoute = useLocation();
  const {state} = locationRoute;
  const params = useParams();
  const id = state && state.id ? state.id : params.id;
  const portalApp = new URLSearchParams(locationRoute.search).get('app') || 'waste';
  const isFire = portalApp === 'fire_pest';
  const navigate = useNavigate();


  const fetchLocation = useCallback(async() => {
    const response = await fetch(`/apilocation/${id}?app=${portalApp}`);
    const location = await response.json();
    if (location && location.sessionExpired) {
      logoutUser();
      return;
    }
    const phone = location && location[36] ? location[36].value : "";
    const address = location && location[8] ? location[8].value : "";
    const nameNumber = location && location[66] ? location[66].value : "";
    const districtNameLocal = location && location[55] ? location[55].value : "";
    const locationNumberLocal = location && location[51] ? location[51].value : "";
    setLocationPhone(phone);
    setLocationAddress(address);
    setLocationName(nameNumber);
    setDistrictName(districtNameLocal);
    setLocationNumber(locationNumberLocal);
    setHasLocationData(true);
  }, [id, portalApp]);

  const fetchSchedules = useCallback(async() => {
    if (isFire) return;
    const response = await fetch(`/apischedules/${id}`);
    const schedules = await response.json();
    if (schedules && schedules.length > 0) {
      setSchedules(schedules);
      setHasSchedules(true);
      formatSchedules(schedules);
    }
  }, [id, isFire])

  const formatSchedules = schedules => {

    const formatSchedulesFinal = [
    ];
    schedules && schedules.forEach(schedule => {
      const address = schedule && schedule[36] ? schedule[36].value : "";
      const pickUpType = schedule && schedule[20] ? schedule[20].value : "";
      const containerCount = schedule && schedule[33] ? schedule[33].value : "";
      const containerSize = schedule && schedule[15] ? schedule[15].value : "";
      const pickUpFreq = schedule && schedule[16] ? schedule[16].value : "";
      const pickUpDays = schedule && schedule[61] ? schedule[61].value : "";
      const hasDumpsterLock = schedule && schedule[44] ? schedule[44].value : "";
      const hasDumpsterLockText =  hasDumpsterLock === '1' ? "Yes" :"No";
      formatSchedulesFinal.push([address, pickUpType, containerCount, containerSize, pickUpFreq, pickUpDays, hasDumpsterLockText]);
    })
    setFormattedSchedules(formatSchedulesFinal)
  }

  useEffect(() => {
    if (hasLocationData === false) {
      fetchLocation();
    }
    if (!isFire && schedules.length === 0) {
      fetchSchedules();
    }
    if (formattedSchedules.length === 0) {
      formatSchedules()
    }
  }, [hasLocationData, schedules, fetchLocation, fetchSchedules, isFire])

  const redirectToschedulePage = (e, scheduleId) => {
    navigate(`/schedule/${scheduleId}`, {state: {id: scheduleId}});
  }

  const handleRedirectCreateTicket = () => {
    navigate("/createTicket");
  }

  return (
    <div className="location detailPage">
      {hasLocationData && (
      <>
        <header className="detailHero"><div><span className="detailEyebrow">Client location</span><h2>{formatDisplayValue(locationName)}</h2><p>View location information{isFire ? ' and create an Inspections & Maintenance service request.' : ', service schedules, and request support.'}</p></div><span className="detailAppBadge">{isFire ? 'Inspections & Maintenance' : 'Waste'}</span></header>
        <section className="detailCard locationDetailsWrapper">
          <div className="detailCardHeader"><div><h3>Location details</h3><p>Contact and account information for this service location.</p></div></div>
          <div className="detailGrid">
            <div className="detailField"><span>Location code</span><strong>{formatDisplayValue(locationName)}</strong></div>
            {!isFire && <div className="detailField"><span>District</span><strong>{formatDisplayValue(districtName)}</strong></div>}
            <div className="detailField"><span>Phone</span><strong>{formatDisplayValue(locationPhone)}</strong></div>
            <div className="detailField"><span>Address</span><strong>{formatDisplayValue(locationAddress)}</strong></div>
          </div>
          <div className="detailActions">
            {!isFire && <LocationPosterButton locationNumber={locationNumber} districtName={districtName} formattedSchedules={formattedSchedules} />}
            <button onClick={handleRedirectCreateTicket} className="mainButton detailPrimaryAction">+ New Service Request</button>
          </div>
        </section>
      </>
    )}
  {!isFire && <section className="schedulesList detailTableCard">
  <div className="detailCardHeader"><div><h3>Waste &amp; Recycling Schedules</h3><p>Current service schedules for this location.</p></div></div>
  <div className="tableScroll"><table id="tableWrapper">
        <tbody>
        <tr>
          <th>Location Number</th>
          <th>Location Code</th>
          <th>Address</th>
          <th>Pick-Up Type</th>
          <th>Container Count</th>
          <th>Container Size</th>
          <th>Pick-Up Freq.</th>
          <th>Pick-Up Days</th>
          <th>Has Dumpster Lock</th>
        </tr>
          {hasSchedules && schedules.map((schedule, idx) => {
            const scheduleId = schedule && schedule[3].value ? schedule[3].value : null;
            const hasDumpsterLock = schedule && schedule[44] ? schedule[44].value : "";
            const hasDumpsterLockText =  hasDumpsterLock === '1' ? "Yes" :"No";
            return (
              <tr key={idx} onClick={(e) => redirectToschedulePage(e, scheduleId)} className="tableRow">
                <td className="tableCell">{schedule && schedule[66] ? schedule[66].value : ""}</td>
                <td className="tableCell">{schedule && schedule[21] ? schedule[21].value : ""}</td>
                <td className="tableCell">{schedule && schedule[36] ? schedule[36].value : ""}</td>
                <td className="tableCell">{schedule && schedule[20] ? schedule[20].value : ""}</td>
                <td className="tableCell">{schedule && schedule[33] ? schedule[33].value : ""}</td>
                <td className="tableCell">{schedule && schedule[15] ? schedule[15].value : ""}</td>
                <td className="tableCell">{schedule && schedule[16] ? schedule[16].value : ""}</td>
                <td className="tableCell">{schedule && schedule[61] ? schedule[61].value : ""}</td>
                <td className="tableCell">{hasDumpsterLockText}</td>
              </tr>
            )
          })}
          </tbody>
      </table></div>
  </section>}
    </div>
  )
}
